<template>
    <b-modal :id="modalId" size="xl" title="报价单(견적서)" @show="onShow" @shown="syncQuotation" @hidden="onHidden" hide-footer>
        <div v-if="quotation">
            <!-- 견적서 헤더 -->
            <div class="quotation-header mb-4">
                <h5 class="text-center mb-3">代购报价单(구매대행 견적서)</h5>
                <div class="row">
                    <div class="col-md-6">
                        <p><strong>申请日期(신청날짜):</strong> {{ getFormattedDate(quotation.신청날짜) }}</p>
                        <p><strong>公司名(업체명):</strong> {{ quotation.업체명 }}</p>
                        <p><strong>申请人(요청자):</strong> {{ quotation.요청자 }}</p>
                    </div>
                    <div class="col-md-6 text-right">
                        <p><strong>状态(상태):</strong> <b-badge :variant="getStatusVariant(quotation.상태)">{{ statusText(quotation.상태) }}</b-badge></p>
                        <p><strong>汇率(환율):</strong> {{ quotation.환율 }} KRW/CNY</p>
                    </div>
                </div>
            </div>

            <!-- 견적서 테이블 -->
            <div class="table-responsive">
                <table class="table table-bordered quotation-table">
                    <thead class="thead-light">
                        <tr>
                            <th>商品名<br><small>상품명</small></th>
                            <th>条码<br><small>바코드</small></th>
                            <th>选项信息<br><small>옵션정보</small></th>
                            <th>采购数量<br><small>구매수량</small></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ quotation.상품명 }}</td>
                            <td>{{ quotation.바코드 }}</td>
                            <td>{{ quotation.옵션정보 || '-' }}</td>
                            <td class="text-right">{{ quotation.구매수량 }}</td>
                        </tr>
                    </tbody>
                </table>

                <table class="table table-bordered quotation-table mt-3">
                    <thead class="thead-light">
                        <tr>
                            <th colspan="3" class="text-center">协商前<br><small>협상전</small></th>
                            <th colspan="3" class="text-center">协商后<br><small>협상후</small></th>
                        </tr>
                        <tr>
                            <th>采购单价(CNY)<br><small>구매단가</small></th>
                            <th>运费(CNY)<br><small>배송비</small></th>
                            <th>总金额(CNY)<br><small>총금액</small></th>
                            <th>采购单价(CNY)<br><small>구매단가</small></th>
                            <th>运费(CNY)<br><small>배송비</small></th>
                            <th>1688付款金额(CNY)<br><small>1688결제금액</small></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-right">{{ formatNumber(quotation.협상전_구매단가_CNY) }}</td>
                            <td class="text-right">{{ formatNumber(quotation.협상전_배송비_CNY) }}</td>
                            <td class="text-right">{{ formatNumber(quotation.협상전_총금액_CNY) }}</td>
                            <td class="text-right">{{ formatNumber(quotation.협상후_구매단가_CNY) }}</td>
                            <td class="text-right">{{ formatNumber(quotation.협상후_배송비_CNY) }}</td>
                            <td class="text-right font-weight-bold">{{ formatNumber(quotation.협상후_1688결제금액_CNY) }}</td>
                        </tr>
                    </tbody>
                </table>

                <table class="table table-bordered quotation-table mt-3">
                    <thead class="thead-light">
                        <tr>
                            <th>付款金额(KRW)<br><small>결제금액</small></th>
                            <th>增值税(10%)<br><small>부가세</small></th>
                            <th>最终合计(KRW)<br><small>최종금액합계</small></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-right">{{ formatNumber(quotation.결제금액_KRW) }}</td>
                            <td class="text-right">{{ formatNumber(quotation.부가세) }}</td>
                            <td class="text-right font-weight-bold text-primary" style="font-size: 1.1em;">
                                {{ formatNumber(quotation.최종금액합계_KRW) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- 메모 -->
            <div v-if="quotation.메모" class="mt-3">
                <p><strong>备注(메모):</strong></p>
                <p class="border p-2 bg-light">{{ quotation.메모 }}</p>
            </div>

            <!-- 버튼 -->
            <div class="mt-4 d-flex justify-content-between">
                <div>
                    <b-button variant="success" @click="downloadExcel" class="mr-2">
                        <b-icon icon="file-earmark-excel"></b-icon> 下载Excel(엑셀 다운로드)
                    </b-button>
                </div>
                <div>
                    <b-button variant="secondary" @click="closeModal">
                        关闭(닫기)
                    </b-button>
                </div>
            </div>
        </div>
        <div v-else class="text-center p-5">
            <b-spinner></b-spinner>
            <p class="mt-2">报价单加载中...(견적서를 불러오는 중)</p>
        </div>
    </b-modal>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
    name: 'QuotationModal',
    props: {
        modalId: {
            type: String,
            default: 'quotation-modal'
        },
        quotationData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            quotation: null
        };
    },
    methods: {
        onShow() {
            this.quotation = this.quotationData;
        },
        // 부모가 데이터를 넣자마자 모달을 열면 @show 시점엔 prop 이 아직 옛 값(null)이라 «加载中» 에 멈춘다 — 늦게 들어온 값도 받는다
        syncQuotation() {
            if (this.quotationData && !this.quotation) this.quotation = this.quotationData;
        },
        onHidden() {
            this.quotation = null;
        },
        closeModal() {
            this.$bvModal.hide(this.modalId);
        },
        getFormattedDate(timestamp) {
            if (!timestamp) return '-';
            const date = new Date(timestamp);
            return date.toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        // 상태 표시만 중국어(한국어) — 저장값(quotation.상태)은 그대로
        statusText(status) {
            const zh = { '견적서생성': '报价单已生成', '발송완료': '已发送', '입금확인': '确认入账', '결제완료': '已付款' }[status];
            return zh ? zh + '(' + status + ')' : status;
        },
        getStatusVariant(status) {
            const variants = {
                '견적서생성': 'info',
                '발송완료': 'primary',
                '입금확인': 'warning',
                '결제완료': 'success'
            };
            return variants[status] || 'secondary';
        },
        formatNumber(num) {
            if (num === null || num === undefined) return '0';
            return Number(num).toLocaleString('ko-KR');
        },
        downloadExcel() {
            if (!this.quotation) return;

            // 엑셀 데이터 준비
            const excelData = [
                {
                    '신청날짜': this.getFormattedDate(this.quotation.신청날짜),
                    '업체명': this.quotation.업체명,
                    '요청자': this.quotation.요청자,
                    '상품명': this.quotation.상품명,
                    '구매수량': this.quotation.구매수량,
                    '협상전 구매단가(CNY)': this.quotation.협상전_구매단가_CNY,
                    '협상전 배송비(CNY)': this.quotation.협상전_배송비_CNY,
                    '협상전 총금액(CNY)': this.quotation.협상전_총금액_CNY,
                    '협상후 구매단가(CNY)': this.quotation.협상후_구매단가_CNY,
                    '협상후 배송비(CNY)': this.quotation.협상후_배송비_CNY,
                    '협상후 1688결제금액(CNY)': this.quotation.협상후_1688결제금액_CNY,
                    '결제금액(KRW)': this.quotation.결제금액_KRW,
                    '부가세': this.quotation.부가세,
                    '최종금액합계(KRW)': this.quotation.최종금액합계_KRW,
                    '바코드': this.quotation.바코드
                }
            ];

            // 엑셀 파일 생성
            const workBook = XLSX.utils.book_new();
            const workSheet = XLSX.utils.json_to_sheet(excelData);

            // 컬럼 너비 설정
            const wscols = [
                { wch: 20 }, // 신청날짜
                { wch: 15 }, // 업체명
                { wch: 15 }, // 요청자
                { wch: 30 }, // 상품명
                { wch: 10 }, // 구매수량
                { wch: 18 }, // 협상전 구매단가
                { wch: 18 }, // 협상전 배송비
                { wch: 18 }, // 협상전 총금액
                { wch: 18 }, // 협상후 구매단가
                { wch: 18 }, // 협상후 배송비
                { wch: 22 }, // 협상후 1688결제금액
                { wch: 15 }, // 결제금액(KRW)
                { wch: 12 }, // 부가세
                { wch: 18 }, // 최종금액합계
                { wch: 20 }  // 바코드
            ];
            workSheet['!cols'] = wscols;

            XLSX.utils.book_append_sheet(workBook, workSheet, '견적서');

            // 파일명 생성
            const fileName = `견적서_${this.quotation.바코드}_${this.getToday()}.xlsx`;
            XLSX.writeFile(workBook, fileName);
        },
        getToday() {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (1 + date.getMonth())).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            return year + month + day;
        }
    }
};
</script>

<style scoped>
.quotation-header {
    border-bottom: 2px solid #dee2e6;
    padding-bottom: 1rem;
}

.quotation-table {
    font-size: 0.9rem;
}

.quotation-table th {
    background-color: #f8f9fa;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
}

.quotation-table td {
    vertical-align: middle;
}

.quotation-table .text-right {
    text-align: right;
}
</style>


